(function () {
  function initSlider(track) {
    var outer = track.closest('.cls-slider-outer');
    if (!outer) return;
    var prev = outer.querySelector('[data-cls-prev]');
    var next = outer.querySelector('[data-cls-next]');

    function cardStep() {
      var card = track.querySelector('.cls-card');
      if (!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '16') || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep() * 2, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep() * 2, behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-cls-track]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when a section is added/updated live in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var track = e.target.querySelector && e.target.querySelector('[data-cls-track]');
    if (track) initSlider(track);
  });
})();
